import { PageLocatorMap } from '../types/PageLocatorMap';

export const loanDocumentListPage = {
  footer: {
    root: 'loan-document-list-page.footer.root',
  },
  form: {
    gapListItemLink: 'loan-document-list-page.form.gap-list-item-link',
    gapListItemRoot: 'loan-document-list-page.form.gap-list-item-root',
    h1: 'loan-document-list-page.form.h1',
    h2: 'loan-document-list-page.form.h2',
    ricListItemLink: 'loan-document-list-page.form.ric-list-item-link',
    ricListItemRoot: 'loan-document-list-page.form.ric-list-item-root',
    root: 'loan-document-list-page.form.root',
    vscListItemLink: 'loan-document-list-page.form.vsc-list-item-link',
    vscListItemRoot: 'loan-document-list-page.form.vsc-list-item-root',
  },
  header: {
    drawerButton: 'loan-document-list-page.header.drawer-button',
    previousStepButton: 'loan-document-list-page.header.previous-step-button',
    root: 'loan-document-list-page.header.root',
    submitButton: 'loan-document-list-page.header.submit-button',
  },
  progress: {
    root: 'loan-document-list-page.progress.root',
  },
} as const satisfies PageLocatorMap;
